import { useMyStore } from "~/stores/myStore"

export const utilLogin = {
    nomeUsuario() {
        let myStore = useMyStore()
        return myStore.dadosLogin != null ? myStore.dadosLogin.NomeUsuario : ''
    },
    ehAdministrador() {
        let myStore = useMyStore()
        return myStore.dadosLogin?.Perfil == 'Administrador'
    },
    ehPesquisador() {
        let myStore = useMyStore()
        return myStore.dadosLogin?.Perfil == 'Pesquisador'
    },
    ehRespondente() {
        let myStore = useMyStore()
        return myStore.dadosLogin?.Perfil == 'Respondente'
    },
    ehSoftjads() {
        let myStore = useMyStore()
        return myStore.dadosLogin?.Email.indexOf('@softjads.com.br' > 0)
    },
    sairDaConta(paginaDestino = '/') {
        let myStore = useMyStore()
        myStore.limparLogin()
        navigateTo(paginaDestino)

        //força recarregamento da página, se já estiver na página inicial.
        if (paginaDestino == '/')
            reloadNuxtApp({ force: true })
    },
    estaLogado() {
        let myStore = useMyStore()
        return myStore.estaLogado
    },
    estaAutorizadoHomologacao (idPesquisadorLogado) {
        return _arrayPesquisadoresHomologacao.find(x => x.toLowerCase() == idPesquisadorLogado) != null
    }

}